export const getMerchantId = (prefill) => prefill?.merchantId || new URLSearchParams(window.location.search).get('merchantId');
export const getAdvisorId = (prefill) => prefill?.advisorId || new URLSearchParams(window.location.search).get('advisorId');
